'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { CollectionContainer } from '../../../../components/common/collection/collection-container'
import { CollectionMixMatchItem } from './collection-mix-match-item'

type Props = {
  title: string
  data: {
    thumbnail: string
    productIds: string[]
    isVideo?: boolean
  }[]
}

export const CollectionMixMatch: React.FC<Props> = ({ title, data }) => {
  const isMobile = useIsMobileClient()

  return (
    <CollectionContainer>
      <div className='mb-4 flex items-center justify-between'>
        <h3 className='font-criteria text-2xl font-medium uppercase text-neutral-900 lg:text-[28px] lg:leading-10'>
          {title}
        </h3>
      </div>

      {isMobile ? (
        <div className='md:hidden'>
          <Carousel
            opts={{
              align: 'start',
              loop: false,
              containScroll: false,
            }}
            className='w-full'
          >
            <CarouselContent className='-ml-4'>
              {data.map((item, index) => (
                <CarouselItem key={index} className='basis-[80%] pl-4'>
                  <CollectionMixMatchItem
                    productIds={item.productIds}
                    thumbnail={item.thumbnail}
                    isVideo={item.isVideo}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselNavigation />
          </Carousel>
        </div>
      ) : (
        <div className='hidden grid-cols-2 gap-4 md:grid lg:grid-cols-4 lg:gap-5'>
          {data.map((item, index) => (
            <CollectionMixMatchItem
              key={index}
              productIds={item.productIds}
              thumbnail={item.thumbnail}
              isVideo={item.isVideo}
            />
          ))}
        </div>
      )}
    </CollectionContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
